// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__Z8yvn"};